import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Grid } from '@material-ui/core';
import i18n from '../../../../locale';
import SectionWrapper from '../../../../components/SectionWrapper';
import Feature from './Feature';
import styles from './styles.module.sass';

export default () => (
  <StaticQuery
    query={graphql`
      query {
        vc1: imageSharp(fluid: {
          originalName : {eq: "Leasing-Feature-1.jpg"}
        }) {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
        vc2: imageSharp(fluid: {
          originalName : {eq: "Leasing-Feature-2.jpg"}
        }) {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
        vc3: imageSharp(fluid: {
          originalName : {eq: "Leasing-Feature-3.jpg"}
        }) {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
        vc4: imageSharp(fluid: {
          originalName : {eq: "Leasing-Feature-4.jpg"}
        }) {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
        vc5: imageSharp(fluid: {
          originalName : {eq: "Leasing-Feature-5.jpg"}
        }) {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        } 
      }
    `}
    render={({ vc1, vc2, vc3, vc4, vc5 }) => (
      <SectionWrapper>
        <Grid item container xs={12} md={12} xl={12}
          alignContent='center'
          justifyContent='center'
          className={styles.container}>
          <Feature title={i18n('Relevant vehicle data')}
            text={i18n('Access to data about mileage, service maintenance, vehicle status and other parameters.')}
            image={vc1}
            layout={{
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              xl: 6
            }}/>
          <Feature title={i18n('Timely reporting')}
            text={i18n('Be informed on time through tailored reports about improper usage like crossing country borders or driving with hazardous vehicle issues.')}
            image={vc2}
            layout={{
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              xl: 6
            }}/>
          <Feature title={i18n('Manage agreements')}
            text={i18n('An automated tool to track leasing agreements making it easier to manage operations and communication with customers.')}
            image={vc3}/>
          <Feature title={i18n('Communication')}
            text={i18n('Improve customer service by communicating with customers through a new convenient channel.')}
            image={vc4}/>
          <Feature title={i18n('Integrate data to other systems')}
            text={i18n('Optimize your leasing business by leveraging data and insights.')}
            image={vc5}/>
        </Grid>
      </SectionWrapper>
    )}/>
);